/* eslint-disable max-len */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ModalRoute } from 'react-router-modal';
import moment from 'moment';

import { SERVER_URL } from '../../../config';
import {
    ApiDropDown,
    BookingSheetStatusDropdown,
    BookingSheetClientStatusDropdown,
} from '../common/dropdowns';
import { SelectRole } from '../../common/SelectRole';
import DateDropDown from '../common/datedropdown';
import RefreshButton from '../../common/refreshbutton';
import SearchBar from '../common/SearchBar';
import ConflictTimesContainer from './conflictTimesContainer';
import CollapsibleTable from './CollapsibleTable';
import BookingDetails from './booking-details/BookingDetails';
import BookingStartTimeWidget from './BookingStartTimeWidget';
import BookingEndTimeWidget from './BookingEndTimeWidget';
import BookingsBulkActions from './bookings-bulk-actions/BookingsBulkActions';
import BookingReviewWidget from './booking-review-widget/BookingReviewWidget';
import { withPushFiltersToUrl } from '../common/decorators';
import history from '../../../history';
import Tooltip from '../../common/Tooltip';
import DelegatedJobReport from './DelegatedJobReport';
import DownloadCSVButton from '../common/downloadCSVButton';

export const getBookingStatusString = job => {
    const effectiveDatetimeStarted = job.booking
        ? job.booking.datetime_started
        : null;
    const effectiveDatetimeFinished = job.booking
        ? job.booking.datetime_finished
        : null;
    let currentStatus;
    const todayDate = moment().format('YYYY-MM-DD');

    // eslint-disable-next-line eqeqeq
    if (job.booking.status === 'OK' && job.date == todayDate) {
        if (!effectiveDatetimeStarted && !effectiveDatetimeFinished) {
            currentStatus = 'Planned';
        } else if (effectiveDatetimeStarted && !effectiveDatetimeFinished) {
            currentStatus = 'Ongoing';
        } else if (effectiveDatetimeStarted && effectiveDatetimeFinished) {
            currentStatus = 'Completed';
        }
    } else if (job.booking.status === 'OK') {
        if (effectiveDatetimeStarted && effectiveDatetimeFinished) {
            currentStatus = 'Completed';
        } else {
            currentStatus = 'Confirmed';
        }
    } else {
        currentStatus = job.booking.status;
    }

    if (job.booking.status === 'UN') {
        currentStatus = 'Unsatisfied';
    }

    if (job.booking.status === 'CA') {
        currentStatus = 'Client cancelled';
    }

    if (job.booking.status === 'FC') {
        currentStatus = 'Worker cancelled';
    }

    if (job.booking.status === 'NS') {
        currentStatus = 'No show';
    }

    if (job.booking.status === 'BU') {
        currentStatus = 'Backup';
    }

    if (job.booking.status === 'BC') {
        currentStatus = 'Backup cancelled';
    }

    return currentStatus;
};

@withPushFiltersToUrl
class BookingsTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedJobs: [],
            isBulkMode: false,
            isBulkExclusiveMode: false,
            // eslint-disable-next-line react/no-unused-state
            expandedBookingId: 3002,
            lastCheckedRowIndex: null,
            lastCheckedRowArrayIndex: null,
        };

        this.onRowCheckboxChange = this.onRowCheckboxChange.bind(this);
        this.isRowChecked = this.isRowChecked.bind(this);
    }

    onRowCheckboxChange(rowInfo, checked, shiftKeyPressed) {
        const { lastCheckedRowIndex, lastCheckedRowArrayIndex, selectedJobs, isBulkExclusiveMode } = this.state;

        const rowIndex = rowInfo.original.id;
        const rowArrayIndex = this.props.data.findIndex(
            object => object.id === rowIndex
        );

        let allSelectedJobs;

        if (shiftKeyPressed && selectedJobs.length > 0) {
            // handle selection with 'shift' key
            const start = Math.min(lastCheckedRowArrayIndex, rowArrayIndex);
            const end = Math.max(lastCheckedRowArrayIndex, rowArrayIndex);

            const rowSelectedJobs = this.props.data.filter(
              (_, index) => index >= start && index <= end
            );

            if (selectedJobs.some(
                job => job.id === lastCheckedRowIndex)
            ) {
                allSelectedJobs = new Set([
                    ...selectedJobs,
                    ...rowSelectedJobs
                ]);
                this.setState({
                    selectedJobs: Array.from(allSelectedJobs),
                });
            } else {
                allSelectedJobs = selectedJobs.filter(
                    job => !rowSelectedJobs.some(
                        selected => selected.id === job.id
                    )
                );
                this.setState({
                    selectedJobs: allSelectedJobs,
                });
            }
        } else if (checked || (isBulkExclusiveMode && !checked)) {
            this.setState({
                selectedJobs: selectedJobs.concat(rowInfo.original),
            });
        } else {
            this.setState({
                selectedJobs: selectedJobs.filter(
                    item =>
                        item.booking.reference_number !==
                        rowInfo.original.booking.reference_number,
                ),
            });
        }
        this.setState({
            lastCheckedRowIndex: rowIndex,
            lastCheckedRowArrayIndex: rowArrayIndex,
        });
    }

    onToggleBulkMode() {
        this.setState({
            // eslint-disable-next-line react/no-access-state-in-setstate
            isBulkMode: !this.state.isBulkMode,
            isBulkExclusiveMode: false,
            selectedJobs: [],
        });
    }

    isRowChecked(rowInfo) {
        const { selectedJobs, isBulkExclusiveMode } = this.state;
        const isInSelectedJobs = !!selectedJobs.find(
            item =>
                item.booking.reference_number ===
                rowInfo.original.booking.reference_number,
        );
        return isBulkExclusiveMode ? !isInSelectedJobs : isInSelectedJobs;
    }

    selectAllRows = () => {
        let allSelectedJobs;
        const allJobs = this.props.data;
        allSelectedJobs = new Set([
            ...this.state.selectedJobs,
            ...allJobs
        ]);
        allSelectedJobs = Array.from(allSelectedJobs);
        this.setState({
            selectedJobs: allSelectedJobs,
        });
    }

    deselectAllRows = () => {
        this.setState({
            selectedJobs: [],
        });
    }

    onFeedbackPostSuccess() {
        this.props.reloadData();
        this.setState({
            selectedJobs: [],
            isBulkMode: false,
            isBulkExclusiveMode: false,
        });
    }

    getCsvDownloadParams(currentUrlParams) {
        const params = new URLSearchParams(currentUrlParams);

        // Add has_bookings=1 (same as fetchBookings function)
        params.set('has_bookings', '1');

        // Apply the same logic as fetchTodayShifts - default to today if no date params
        if (
            !params.get('before') &&
            !params.get('after') &&
            !params.get('getall')
        ) {
            // Default to today's date range
            const startOfToday = moment().startOf('day').toISOString();
            const endOfToday = moment().endOf('day').toISOString();
            params.set('page', '1');
            params.set('after', startOfToday);
            params.set('before', endOfToday);
        }

        return params;
    }

    onFilterChange(...args) {
        this.props.onFilterChange(...args);
        if (this.state.isBulkExclusiveMode) {
            this.setState({
                selectedJobs: [],
                isBulkExclusiveMode: false,
            });
        }
    }

    getExpandedRowViewIndex(data, id) {
        // eslint-disable-next-line eqeqeq
        return data.findIndex(job => job.booking.id == id);
    }

    onExpandRow(rowInfo) {
        const { id } = rowInfo.original.booking;
        history.push({
            pathname: `/operations/bookings/expanded/${id}/`,
            search: this.props.location.search,
        });
    }

    onCollapseRow() {
        const { id } = this.props.match.params;
        const pathname = this.props.location.pathname.replace(
            `/expanded/${id}`,
            '',
        );
        history.push({
            pathname,
            search: this.props.location.search,
        });
    }

    render() {
        const expandedBookingId = this.props.match.params.id;
        const role = this.props.clientData.userData.content.user_type;

        const currentUrlParams = new URLSearchParams(history.location.search);

        return (
            <div className="table-container">
                <div className="table-filter-container">
                    <DateDropDown
                        onFilterChange={this.onFilterChange.bind(this)}
                        history={history}
                    />
                    {(() => {
                        if (role === 'client') {
                            return (
                                <BookingSheetClientStatusDropdown
                                    onFilterChange={this.onFilterChange.bind(
                                        this,
                                    )}
                                    history={history}
                                />
                            );
                        }
                        return (
                            <BookingSheetStatusDropdown
                                onFilterChange={this.onFilterChange.bind(this)}
                                history={history}
                            />
                        );
                    })()}
                    <SelectRole
                        onFilterChange={this.props.onFilterChange}
                        currentUrlParams={currentUrlParams}
                    />
                    {this.props.user.isAgent && (
                        <ApiDropDown
                            onFilterChange={this.props.onFilterChange}
                            currentUrlParams={currentUrlParams}
                            url={`agencies/${this.props.user.agency.id}/agents/`}
                            filterKey='consultant'
                            labelKey='full_name'
                            valueKey='id'
                            verboseNamePlural='consultants'
                        />
                    )}
                    <SearchBar
                        filterKey="search"
                        onFilterChange={this.onFilterChange.bind(this)}
                        currentUrlParams={currentUrlParams}
                    />
                    <div className="table-action-bar">
                        <BookingsBulkActions
                            jobs={this.state.selectedJobs}
                            onSelectAllJobs={this.selectAllRows}
                            onDeselectAllJobs={this.deselectAllRows}
                            isBulkMode={this.state.isBulkMode}
                            isBulkExclusiveMode={this.state.isBulkExclusiveMode}
                            totalNumberOfJobsInTable={
                                this.props.meta.bookings_count ||
                                this.props.meta.count
                            }
                            notification={this.props.notification}
                            onFeedbackPostSuccess={this.onFeedbackPostSuccess.bind(
                                this,
                            )}
                        />
                        {this.props.user.isAgent && (
                            <DownloadCSVButton
                                endpoint="jobs"
                                params={this.getCsvDownloadParams(currentUrlParams)}
                            />
                        )}
                        <RefreshButton reloadData={this.props.reloadData} />
                        <DelegatedJobReport user={this.props.user}/>
                    </div>
                </div>
                <CollapsibleTable
                    // start ReactTable props
                    page={this.props.currentPage}
                    pageSize={0}
                    data={this.props.data}
                    pages={this.props.pages}
                    columns={this.columns}
                    className="table-content"
                    loading={this.props.loading}
                    showPaginationBottom={this.props.showPaginationBottom}
                    showPageSizeOptions={false}
                    manual={true}
                    // eslint-disable-next-line no-return-assign, no-sequences
                    ref={table => (
                        // eslint-disable-next-line no-sequences
                        (this.table = table), this.props.setTable(table)
                    )}
                    fireFetchData={this.props.reloadData}
                    onPageChange={this.props.onPageChange}
                    onSortedChange={this.props.onSortedChange}
                    SubComponent={rowInfo => (
                        <BookingDetails
                            job={rowInfo.original}
                            notification={this.props.notification}
                            location={this.props.location}
                            history={history}
                            match={this.props.match}
                            table={this}
                            onFeedbackPostSuccess={this.onFeedbackPostSuccess.bind(
                                this,
                            )}
                        />
                    )}
                    // end ReactTable props
                    onRowCheckboxChange={this.onRowCheckboxChange}
                    onToggleBulkMode={this.onToggleBulkMode.bind(this)}
                    isBulkMode={this.state.isBulkMode}
                    isRowChecked={this.isRowChecked}
                    expandedRowViewIndex={this.getExpandedRowViewIndex(
                        this.props.data,
                        expandedBookingId,
                    )}
                    onExpandRow={this.onExpandRow.bind(this)}
                    onCollapseRow={this.onCollapseRow.bind(this)}
                    expandUsingURLPrimaryKey={true}
                />
            </div>
        );
    }

    columns = [
        {
            Header: 'Booking Ref.',
            id: 'reference_number',
            sortable: false,
            Cell: data => <span>{data.original.booking.reference_number}</span>,
        },
        {
            Header: 'Job Ref.',
            accessor: 'reference_number',
            id: 'reference_number',
            sortable: false,
            Cell: row => (
                <a href={`${SERVER_URL}/job/${row.original.id}`}>
                    {row.value}
                    {row.original.additional_services?.length &&
                        <Tooltip tooltip={<span>Multi-sector job</span>}>
                            <i className="icon icon-check-double-22 margin-5-px" />
                        </Tooltip>
                    }
                </a>
            ),
        },
        {
            Header: 'Client',
            accessor: 'client_full.company_name',
            show: this.props.user.isAgent,
            sortable: false,
        },
        {
            Header: 'Worker',
            accessor: 'name',
            sortable: false,
            className: 'hide-when-expanded',
            Cell: data => (
                <span>
                    {data.original.booking
                        ? data.original.booking.freelancer_detail.full_name
                        : ''}
                </span>
            ),
        },
        {
            Header: 'Date',
            accessor: 'date',
            className: 'hide-when-expanded',
            Cell: data => (
                <span>{moment(data.value).format('DD/MM/YYYY')}</span>
            ),
        },
        {
            Header: 'Start time',
            accessor: 'start_datetime',
            className: 'hide-when-expanded',
            Cell: data => {
                const role = this.props.clientData.userData.content.user_type;
                const isManagePostJobOps =
                    this.props.clientData.userData.content.permissions.includes(
                        'auth.manage_postjob_ops',
                    );
                if (role === 'client' && !isManagePostJobOps) {
                    return (
                        <div>
                            {moment(
                                data.original.booking.datetime_started
                                    ? data.original.booking.datetime_started
                                    : data.value,
                            ).format('HH:mm')}
                        </div>
                    );
                }
                return (
                    <BookingStartTimeWidget
                        job={data.original}
                        notification={this.props.notification}
                        history={history}
                        table={this}
                        enableModal={true}
                        enableLinkToModal={false}
                        isPreviewMode={true}
                    />
                );
            },
        },
        {
            Header: 'End time',
            accessor: 'end_datetime',
            className: 'hide-when-expanded',
            Cell: data => {
                const role = this.props.clientData.userData.content.user_type;
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                const isClient = role === 'client' && !isManagePostJobOps;
                const isManagePostJobOps =
                    this.props.clientData.userData.content.permissions.includes(
                        'auth.manage_postjob_ops',
                    );
                if (
                    isClient &&
                    (!data.original.booking.clock_out ||
                        !data.original.booking.clock_out.pending)
                ) {
                    return (
                        <div>
                            {moment(
                                data.original.booking.datetime_finished
                                    ? data.original.booking.datetime_finished
                                    : data.value,
                            ).format('HH:mm')}
                        </div>
                    );
                }
                return (
                    <span>
                        <ModalRoute
                            id={data.original.booking.id}
                            path={`${this.props.match.path}/clockin-out/${data.original.booking.id}`}
                            component={ConflictTimesContainer}
                            linkClassName="clock-link"
                            className={
                                isClient
                                    ? 'react-router-modal__modal clock-out-client'
                                    : 'react-router-modal__modal'
                            }
                            props={{
                                job: data.original,
                                notification: this.props.notification,
                                isClient,
                                table: this,
                                history,
                            }}
                            onBackdropClick={() => {
                                const { id } = data.original.booking;
                                const pathname =
                                    this.props.location.pathname.replace(
                                        `clockin-out/${id}`,
                                        '',
                                    );
                                history.push(
                                    pathname + this.props.location.search,
                                );
                            }}
                        />
                        <BookingEndTimeWidget
                            job={data.original}
                            notification={this.props.notification}
                            history={history}
                            table={this}
                            enableModal={true}
                            enableLinkToModal={false}
                            isPreviewMode={true}
                        />
                    </span>
                );
            },
        },
        {
            Header: 'Status',
            accessor: 'status',
            sortable: false,
            className: 'hide-when-expanded',
            Cell: data => (
                <span
                    className={
                        ['CA', 'FC', 'NS', 'BC'].indexOf(
                            data.original.booking.status,
                        ) >= 0
                            ? 'stale'
                            : ''
                    }
                >
                    {getBookingStatusString(data.original)}
                </span>
            ),
        },
        {
            Header: 'Review',
            id: 'booking_review',
            className: 'overflowable',
            sortable: false,
            Cell: data =>
                data.original.booking.can_review ? (
                    <BookingReviewWidget booking={data.original} />
                ) : null,
        },
    ];
}

function mapStateToProps(state) {
    return {
        clientData: state.clientData,
    };
}

export default connect(mapStateToProps)(BookingsTable);
